import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { NewsYearRoutingModule } from './news-year-routing.module';
import { NewsYearListComponent } from './news-year-list/news-year-list.component';
import { NewsYearCreateComponent } from './news-year-create/news-year-create.component';
// import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
// import * as moment from 'moment';

/* export class MomentDateFormatter extends NgbDateParserFormatter {

  readonly DT_FORMAT = 'MM/YYYY';

  parse(value: string): NgbDateStruct {
      if (value) {
          value = value.trim();
          let mdt = moment(value, this.DT_FORMAT)
      }
      return null;
  }
  format(date: NgbDateStruct): string {
      if (!date) return '';
      let mdt = moment([date.year, date.month - 1, date.day]);
      if (!mdt.isValid()) return '';
      return mdt.format(this.DT_FORMAT);
  }
} */

@NgModule({
  declarations: [NewsYearListComponent, NewsYearCreateComponent],
  imports: [
    CommonModule,
    NewsYearRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ],
  // providers:[{provide: NgbDateParserFormatter, useClass: MomentDateFormatter}]
})
export class NewsYearModule { }
